import { render, staticRenderFns } from "./servicePackageTable.vue?vue&type=template&id=c48300f4&scoped=true"
import script from "./servicePackageTable.vue?vue&type=script&lang=js"
export * from "./servicePackageTable.vue?vue&type=script&lang=js"
import style0 from "./servicePackageTable.vue?vue&type=style&index=0&id=c48300f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48300f4",
  null
  
)

export default component.exports